function addJoystick(conf){
    PIXI.Container.call(this);
    conf=$.extend(true,{
        urls:{
            back:_IMG_SERV+"/gfx/place/walkgame/ui/shield.png",
            pointer:_IMG_SERV+"/gfx/place/walkgame/ui/arrow.png"
        },
        url_pref:"addJoystick",
        pointer_pivot:[9,73],
        pos:[1100,390],
        degArr:[],
        in_region:1,
        region_extend:1,
        hide_pointer:0
    },conf);
    this.conf=conf;
    this.pointer;
    this.region=[];


}
addJoystick.prototype = Object.create(PIXI.Container.prototype);
addJoystick.prototype= $.extend(addJoystick.prototype,{
    init:function(){
        var texture = PIXI.utils.TextureCache[this.conf.url_pref+"_back"];
        var back=new PIXI.Sprite(texture);
        back.anchor.set(0.5);
        this.addChild(back);
        if(this.conf.in_region){
            var tmp=[texture.orig.width/2*this.conf.region_extend,texture.orig.height/2*this.conf.region_extend];
            this.region=[
                [this.conf.pos[0]-tmp[0],this.conf.pos[0]+tmp[0]],
                [this.conf.pos[1]-tmp[1],this.conf.pos[1]+tmp[1]]
            ];
        }


        var texturePointer = PIXI.utils.TextureCache[this.conf.url_pref+"_pointer"];
        this.pointer=new PIXI.Sprite(texturePointer);
        this.pointer.pivot.set(this.conf.pointer_pivot[0],this.conf.pointer_pivot[1]);
        this.pointer.y=texturePointer.orig.height-this.conf.pointer_pivot[1];

        this.addChild(this.pointer);
        if(this.conf.hide_pointer){
            this.pointer.alpha=0;
        }

        this.x=this.conf.pos[0];
        this.y=this.conf.pos[1];
    },
    addToPreloader:function(){
        var obj={},key;
        for(key in this.conf.urls){
            obj[this.conf.url_pref+"_"+key]=this.conf.urls[key];
        }
        return obj;
    },
    setPointer:function(pos,pos_use){
        if(this.region.length){
            if(pos[0]<this.region[0][0] || pos[0]>this.region[0][1] ||
            pos[1]<this.region[1][0] || pos[1]>this.region[1][1]
            ){
                return -1;
            }
        }


        var pos_start;
        if(typeof pos_use!="undefined"){
            pos_start=copyArray(pos_use);
        }
        else{
            pos_start=[this.x,this.y]
        }



        var deg=angleClockFromVector(makeVector(pos_start,pos));
        if(this.conf.degArr.length>0){
            var deg_part=360/this.conf.degArr.length;
            var part=Math.floor(((deg+deg_part/2+360)%360)/deg_part);
            deg=this.conf.degArr[part];
        }

        this.pointer.rotation=deg/180*Math.PI;
        return deg;
    }
});
